export function Int_check(input, type) {
  if(type === "grade"){
    var list = ['9','10','11','12'];
    for(var i = 0; i < list.length; i++){
      if(input === list[i]){
        return true;
      }
    }
    return false;
  }else if(type === "period"){
    var list = ['0','1','2','3','4','5','6','7'];
    for(var i = 0; i < list.length; i++){
      if(input === list[i]){
        return true;
      }
    }
    return false;
  }else{
    alert("hello There");
    return false;
  }
}

export function Number_check(a, b) {
  return a - b;
}



// WEBPACK FOOTER //
// ./src/Limitation.js